var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crosshair-marks",style:({ color: _vm.color }),attrs:{"aria-hidden":"true"}},_vm._l((_vm.marks),function(mark,index){return _c('div',{key:index,class:['crosshair-mark', ("is-" + (mark.type))],style:(mark.style)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }